import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/svgs/seller.svg';
import _imports_1 from '@/assets/svgs/clock.svg';
const _hoisted_1 = { class: "col-12" };
const _hoisted_2 = { class: "campaigns-management-type__header" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_4 = { class: "campaigns-management-type__description" };
const _hoisted_5 = { class: "campaigns-management-type__container" };
const _hoisted_6 = { class: "campaigns-management-type__content" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1);
const _hoisted_8 = { class: "campaigns-management-type__content" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_1 }, null, -1);
import { computed } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import { channel } from '@/utilities/constants';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsManagementType',
    setup(__props) {
        const store = useStore();
        const computedSelectedType = computed({
            get: () => {
                return store.state.campaignsManagement.automaticAction.sendChannel;
            },
            set: type => {
                store.dispatch('campaignsManagement/setAutomaticAction', { name: 'sendChannel', value: type });
            },
        });
        const isEditingAutomaticAction = computed(() => {
            return router.currentRoute.value.params?.id;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.details.type.title')) + " ", 1),
                        _hoisted_3
                    ]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('360.campaigns.details.type.text')), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", {
                        class: _normalizeClass(["campaigns-management-type__block", {
                                'campaigns-management-type__block--selected': computedSelectedType.value === _unref(channel).SELLER,
                                'campaigns-management-type__block--disabled': computedSelectedType.value === _unref(channel).NON_OFFICIAL && isEditingAutomaticAction.value,
                            }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedSelectedType).value = $event)),
                            name: "messageMode",
                            value: 1
                        }, null, 512), [
                            [_vModelRadio, computedSelectedType.value]
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('360.campaigns.details.type.seller')), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('360.campaigns.details.type.seller-text')), 1)
                        ])
                    ], 2),
                    _createElementVNode("label", {
                        class: _normalizeClass(["campaigns-management-type__block", {
                                'campaigns-management-type__block--selected': computedSelectedType.value === _unref(channel).NON_OFFICIAL,
                                'campaigns-management-type__block--disabled': computedSelectedType.value === _unref(channel).SELLER && isEditingAutomaticAction.value,
                            }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((computedSelectedType).value = $event)),
                            name: "messageMode",
                            value: 2
                        }, null, 512), [
                            [_vModelRadio, computedSelectedType.value]
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('360.campaigns.details.type.automatic')), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('360.campaigns.details.type.automatic-text')), 1)
                        ])
                    ], 2)
                ])
            ]));
        };
    }
});
